import { render, staticRenderFns } from "./ai-face-swap-use.vue?vue&type=template&id=d478a3e6&lang=pug&"
import script from "./ai-face-swap-use.vue?vue&type=script&lang=js&"
export * from "./ai-face-swap-use.vue?vue&type=script&lang=js&"
import style0 from "./ai-face-swap-use.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports